import sync from "../../core/sync.js";

/**
 * `loadingService` is used to handle the fake long polling while loading
 * a document data.
 */

function loadingService() {
	const that = {};

	that.loadCompany = function (options) {
		const id = options.id;
		const callback = options.callback;
		const onError = options.onError;

		const threshold = 1000;

		sync.get(loadingPath(id), {
			success: function (data) {
				const done = data.isLoaded;
				if (done) {
					callback();
				} else {
					setTimeout(() => {
						that.loadCompany(options);
					}, threshold);
				}
			},
			error: onError,
		});
	};

	function loadingPath(id) {
		return `/Shared/Company/${id}/Load`;
	}

	return that;
}

export default loadingService();
